import { RequestController } from '../request/controller';
import { CacheController } from '../cache/controller';
import {PaginationMeta} from '../../types';
import {User} from '../../types/user';
import {EnvModel} from '../env/model';

export class API {
  constructor(
    protected request: RequestController,
    protected cache: CacheController,
    protected env: EnvModel
  ) {}
}

export interface APIResponse<T> {
  data: T
}

export interface APIPaginatedResponse<T> {
  data: T,
  meta: {
    pagination: PaginationMeta
  }
}
export interface UserStatusResponse {
  status: boolean;
  user?: User;
}